<template>
  <div class='h100-80 h-scroll'>
    <ejs-grid ref="dataOfPmNoRealTaskList" :dataSource="gnbPmTaskData" :rowSelected='rowSelectedOfPmGnbTaskList' :rowDeselected='rowDeselectedOfPmGnbTaskList'>
      <e-columns>
        <e-column field='neName' :headerText='$t("Pm.resourceName")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neVersion' :headerText='$t("Pm.resourceVersion")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neIp' :headerText='$t("Pm.resourceIp")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='nePort' :headerText='$t("Pm.resourcePort")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='reportCycle' :headerText='$t("Pm.reportCycle")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="cycleFormatter"></e-column>
        <e-column field='enableStatus' :headerText='$t("Pm.taskStatus")' :disableHtmlEncode='false' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="enableStatusFormatter"></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref="pagerForPmNoRealTaskList" :currentPage='page.currentPage' :pageCount='page.pageCount' :pageSize='page.pageSize' :totalRecordsCount='page.totalRecordsCount'></ejs-pager>
  </div>
</template>

<script>
    export default {
        name: "PmTaskManagementListForGnb",
        data() {
          return {
            gnbPmTaskData: [],
            page: {
              currentPage: 1,
              pageSize: 25,
              totalRecordsCount: 0,
              pageCount: 10
            },
            rowDataOfPmGnbTaskList: '',
            reportCycle: new Map()
              .set('300', this.$t('Pm.fiveMinutes'))
              .set('900', this.$t('Pm.fifteenMinutes'))
              .set('1800', this.$t('Pm.thirtyMinutes'))
              .set('3600', this.$t('Pm.oneHour'))
              .set('86400', this.$t('Pm.oneDay')),
          }
        },
        methods:{

          cycleFormatter(column,data){
            return this.reportCycle.get(data[column.field]);
          },

          enableStatusFormatter(column,data){
            return data[column.field] == '0' ? `<span class='task-disable'>${this.$t('Pm.disable')}</span>`: `<span class='task-enable'>${this.$t('Pm.enable')}</span>`;
          },

          async getTaskListOfGnbPmTask(){
            const This = this;
            This.page.currentPage = This.$refs.pagerForPmNoRealTaskList.ej2Instances.currentPage;
            this.$axios.post('/lte/ems/pm/gnb/getTaskListData.html', {
              page: {
                pageNo: This.page.currentPage,
                pageSize: This.page.pageSize
              }
            }).then((response) => {
              const result = response.data.resultVal;
              This.page.totalRecordsCount = result.totalCount;
              This.page.currentPage = result.pageNo;
              This.gnbPmTaskData = result.result;
            });
          },
          rowSelectedOfPmGnbTaskList(msg) {
            this.rowDataOfPmGnbTaskList = msg.data;
            this.$emit('enableStatusChange', msg.data.enableStatus);
          },
          rowDeselectedOfPmGnbTaskList(msg) {
            this.rowDataOfPmGnbTaskList = '';
            this.$emit('enableStatusChange', '2');
          },
        },
        mounted() {
          this.$loading.showLoadding(this.$t('System.loading'));
          this.getTaskListOfGnbPmTask();
          this.$loading.hideLoadding();
        },
    }
</script>

<style>
  .task-enable,
  .task-disable {
    font-size: 12px;
    display: inline-block;
    width: 50px;
    height: 22px;
    color: #fff;
    line-height: 22px;
  }

  .task-disable{
    background-color: #FF0000;
  }

  .task-enable {
    background-color: #13C2C2;
  }
</style>
